// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1hmS6","selected":"Chip_selected__wa5HG"};